import { render, staticRenderFns } from "./uploadTheYear.vue?vue&type=template&id=72ff34dc&scoped=true&"
import script from "./uploadTheYear.vue?vue&type=script&lang=js&"
export * from "./uploadTheYear.vue?vue&type=script&lang=js&"
import style0 from "./uploadTheYear.vue?vue&type=style&index=0&id=72ff34dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff34dc",
  null
  
)

export default component.exports